import { useQuery } from 'react-query';
import { getUserFeedback, getPendingFeedback } from '../mutations/feedback';

export const useUserFeedback = (uid) => {
  const { data: feedback = [], isLoading, error } = useQuery(
    ['user-feedback', uid],
    () => getUserFeedback(uid),
    {
      enabled: !!uid,
      staleTime: 1000 * 60 * 5,
    }
  );

  return { feedback, isLoading, error };
};

export const usePendingFeedback = (gymUid) => {
  const { data: pending = [], isLoading, error } = useQuery(
    ['pending-feedback', gymUid],
    () => getPendingFeedback(gymUid),
    {
      enabled: !!gymUid,
      staleTime: 1000 * 30,
    }
  );
  return { pending, isLoading, error };
};
